<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" #form="ngForm">
  <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <input matInput required [readonly]="isReadonly('cloudId')" formControlName="cloudId" placeholder="{{ 'forms.login.labels.cloudId' | translate }}" />
        <mat-error>{{ getError("cloudId") }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <input matInput required [readonly]="isReadonly('username')" formControlName="username" placeholder="{{ 'forms.login.labels.username' | translate }}" />
        <mat-error>{{ getError("username") }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <input
          matInput
          required
          type="{{ passwordVisible ? 'text' : 'password' }}"
          [readonly]="isReadonly('password')"
          formControlName="password"
          placeholder="{{ 'forms.login.labels.password' | translate }}"
        />
        <mat-error>{{ getError("password") }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="withSubmit" class="row justify-content-end mt-2">
    <div class="col-md-auto">
      <button mat-raised-button [appButtonLoading]="formLoading.loading" color="primary">
        {{ submitText | translate }}
      </button>
    </div>
  </div>
</form>
